@if (referredOutEmail() && isInternalReferral()) {
    <sh-user-identifier [name]="internalUserName()" [showLabel]="false" id="avatar"></sh-user-identifier>
    <sh-tooltip [label]="referredOutEmail()" target="avatar" placement="top" variation="short"></sh-tooltip>
} @else if (referredOutTeam()) {
    <div class="flex items-center">
        <div
            class="w-8 h-8 rounded-full bg-shui-support-2-shade text-shui-text-active flex items-center justify-center"
            id="team-name"
        >
            {{ teamInitials() }}
        </div>
        <span class="ml-2 text-sm font-medium">
            {{ teamName() }}
        </span>
    </div>
    <sh-tooltip [label]="teamName()" target="team-name" placement="top" variation="short"></sh-tooltip>
} @else {
    <div class="w-8 h-8 rounded-full bg-shui-base-4 flex items-center justify-center">
        <sh-icon icon="sign-out" size="s" class="scale-[0.9] !w-[20px] !h-[20px]" id="user-external"></sh-icon>
    </div>
    <sh-tooltip [label]="referredOutEmail()" target="user-external" placement="top" variation="short"></sh-tooltip>
}
